export enum Environment {
  PROD = 'prd',
  MAJSTG = 'majstg',
  DEVMAJ = 'devmaj',
  LOCAL = 'local',
}

export enum Host {
  PROD = 'www.sunrun.com',
  BETA = 'beta.sunrun.com',
  MAJSTG = 'majstg-www.sunrun.com',
  DEVMAJ = 'devmaj-www.sunrundev.com',
  PREVIEW_DEVMAJ = 'devmaj-preview.sunrundev.com',
  PREVIEW_PRD = 'preview.sunrun.com',
  PORTAL_DEVMAJ = 'devmaj-portal.sunrundev.com',
  PORTAL_PREVIEW_DEVMAJ = 'devmaj-portal-preview.sunrundev.com',
  PORTAL_MAJSTG = 'majstg-portal.sunrun.com',
  PORTAL_PROD = 'portal.sunrun.com',
  LOCAL = 'localhost:3000',
}

export default function getEnv(): Environment {
  if (typeof window !== 'undefined') {
    switch (window.location.hostname) {
      case Host.PROD:
      case Host.BETA:
      case Host.PORTAL_PROD:
        return Environment.PROD;
      case Host.MAJSTG:
      case Host.PREVIEW_PRD:
      case Host.PORTAL_MAJSTG:
        return Environment.MAJSTG;
      case Host.DEVMAJ:
      case Host.PREVIEW_DEVMAJ:
      case Host.PORTAL_DEVMAJ:
      case Host.PORTAL_PREVIEW_DEVMAJ:
        return Environment.DEVMAJ;
      default:
        return Environment.LOCAL;
    }
  }

  const envName = process?.env?.ENV_NAME;

  if (Object.values(Environment).includes(envName as Environment)) {
    return envName as Environment;
  }

  return Environment.LOCAL;
}
